export default (theme) => ({
  background: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
